export const DISPLAY_STYLE = {
  EMOJI: 'emoji',
  STAR: 'star',
  STANDARD: 'standard',
  NUMBERED: 'numbered',
  DROPDOWN: 'dropdown',
  SELECTBOX: 'selectbox',
  GRAPHICS: 'graphics',
} as const;

export type DisplayStyle = (typeof DISPLAY_STYLE)[keyof typeof DISPLAY_STYLE];

export const API_STYLE_VALUE = {
  EMOJI: 'EMOJI',
  STAR: 'STAR',
  RADIO: 'RADIO',
  GRAPHIC: 'GRAPHIC',
  SLIDER: 'SLIDER',
  CSAT: 'CSAT',
  SMILEY: 'SMILEY',
  FACE: 'FACE',
  DROP: 'DROP',
  SELECT: 'SELECT',
  NUMBER: 'NUMBER',
} as const;

export const NPS_BUTTON_STYLE = {
  EMOJI: 'emoji',
  RADIO: 'radio',
  NUMBERED: 'numbered',
  STANDARD: 'standard',
} as const;
